// extracted by mini-css-extract-plugin
export default {"badgeLayer":"badge_badgeLayer__JphQW"};